import { fontsPath } from '~/defaults';

const fontFace = (
    format: string,
    family: string,
    weight: number,
    localName: string,
    fileName: string
) => {
    const woffFormat = `url('${fontsPath}/${fileName}/${fileName}.woff2') format('woff2'),
            url('${fontsPath}/${fileName}.woff') format('woff')`;

    const ttfFormat = `url('${fontsPath}/${fileName}.ttf') format('truetype');`;

    return `@font-face {
        font-family: ${family};
        font-style: normal;
        font-weight: ${weight};
        src:
            local('${localName}'),
            ${format === 'woff' ? woffFormat : ttfFormat};
  }`;
};

// prettier-ignore
export const fonts = `
    ${fontFace('woff', 'Open Sans', 400, 'Open Sans', 'open-sans-400')}
    ${fontFace('woff', 'Open Sans', 600, 'Open Sans Semibold', 'open-sans-600')}
    ${fontFace('woff', 'Raleway', 700, 'Raleway Bold', 'raleway-modified-700')}
`;

export default fonts;
